import { render, staticRenderFns } from "./setForeverGoods.vue?vue&type=template&id=a0b77ac4&scoped=true"
import script from "./setForeverGoods.vue?vue&type=script&lang=js"
export * from "./setForeverGoods.vue?vue&type=script&lang=js"
import style0 from "./setForeverGoods.vue?vue&type=style&index=0&id=a0b77ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b77ac4",
  null
  
)

export default component.exports